module.exports = __webpack_public_path__ + "img/ken-cheung-KonWFWUaAuk-unsplash.951d475c.jpg";